import wx from 'weixin-js-sdk';
var $ = require( "jquery" );
// var wx = require( "./weixin-1.2.0.js" );

var base64EncodeChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var base64DecodeChars = new Array(
      -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
      -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
      -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 62, -1, -1, -1, 63,
      52, 53, 54, 55, 56, 57, 58, 59, 60, 61, -1, -1, -1, -1, -1, -1,
      -1,  0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14,
      15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, -1, -1, -1, -1, -1,
     -1, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40,
      41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, -1, -1, -1, -1, -1);

function base64encode(str) {
    var out, i, len;
    var c1, c2, c3;
    len = str.length;
    i = 0;
    out = "";
    while(i < len) {
		c1 = str.charCodeAt(i++) & 0xff;
		if(i == len) {
			out += base64EncodeChars.charAt(c1 >> 2);
			out += base64EncodeChars.charAt((c1 & 0x3) << 4);
			out += "==";
			break;
		}
		c2 = str.charCodeAt(i++);
		if(i == len) {
			out += base64EncodeChars.charAt(c1 >> 2);
			out += base64EncodeChars.charAt(((c1 & 0x3)<< 4) | ((c2 & 0xF0) >> 4));
			out += base64EncodeChars.charAt((c2 & 0xF) << 2);
			out += "=";
			break;
		}
		c3 = str.charCodeAt(i++);
		out += base64EncodeChars.charAt(c1 >> 2);
		out += base64EncodeChars.charAt(((c1 & 0x3)<< 4) | ((c2 & 0xF0) >> 4));
		out += base64EncodeChars.charAt(((c2 & 0xF) << 2) | ((c3 & 0xC0) >>6));
		out += base64EncodeChars.charAt(c3 & 0x3F);
    }
    return out;
}

function getUrlParam(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
    var r = window.location.search.substr(1).match(reg);  //匹配目标参数
    if (r != null) return unescape(r[2]); return null; //返回参数值
}

export let initwmtshare = (stitle,sdec,shareurl,simg,openid,scampaignname,httpurl) => {
	var awjs_openid = getUrlParam("orgopenId");
	var awjs_sareopenid = getUrlParam("shareOpenId");
	var surl = httpurl + 'wmt/grant/read/'+openid+'/'+scampaignname+'/' + awjs_openid + '/'+base64encode(encodeURIComponent(shareurl));
	var zurl = httpurl + 'wmt/grant/relayRecord?openId=' + openid + '&newsId=' + scampaignname + '&replyOpenId=' + awjs_openid + '&shareOpenId=' + awjs_sareopenid;
	var awjs_appId = "";
	var awjs_timestamp = "";
	var awjs_nonceStr = "";
	var awjs_signature = "";
	$.ajax({
		url: httpurl + "scrm-imr/shareJsNew",
		type: "post",
		data: "openId="+openid+"&url=" +encodeURIComponent(document.URL),
		dataType: "json", 
		cache: false,
		async: true,
		success: function (data, status) {
			//获取传回的信息；			
			if(data.result == 1) {	
				awjs_appId = data.appId;
				awjs_timestamp = data.timestamp;
				awjs_nonceStr = data.nonceStr;
				awjs_signature = data.signature;
				is_awjs_appId();
			} else {
				alert("获取微信签名时中发生异常");
			}
		},
		error: function(obj,info,errObj){
			alert("获取微信签名时中发生错误：" + info);
		}
	});	
	function is_awjs_appId(){
		if(awjs_appId != "") {
			wx.config({   //作用就是权限验证
				debug : false,  //如果要调试 改为true
				appId : awjs_appId,  //填写接口返回json数据的appId
				timestamp : awjs_timestamp,//填写接口返回json数据的timestamp
				nonceStr : awjs_nonceStr, //填写接口返回json数据的nonceStr
				signature : awjs_signature,//填写接口返回json数据的signature
				jsApiList : [ 'checkJsApi', 'onMenuShareTimeline',
						'onMenuShareAppMessage' ]
			});		
			wx.ready(function () {			
				wx.onMenuShareAppMessage({
					title: stitle, // 分享标题
					desc: sdec, // 分享描述
					link: surl+'/appmessage', // 分享链接(自定义链接 可记录阅读信息)
					imgUrl: simg, // 分享图标
					type: '', // 分享类型,music、video或link，不填默认为link
					dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
					success: function () { 
						$.ajax({
							url: zurl+'&from=appmessage',
							cache: false,
							success: function(data) {
								
							},
							error: function() {
							}
						});
					},
					cancel: function () { 
						//alert("取消转发");// 用户取消分享后执行的回调函数
					}
				});
				
				wx.onMenuShareTimeline({
					title: stitle, // 分享标题
					link: surl+'/timeline', // 分享链接(自定义链接 可记录阅读信息)
					imgUrl: simg,// 分享图标
					success: function () { 
						$.ajax({
							url: zurl+'&from=timeline',
							cache: false,
							success: function(data) {
								
							},
							error: function() {
							}
						});
					},
					cancel: function () { 
					}
				});
			});
		}
	}

}
